<template>
  <div id="app all-exchanges">
    <div v-if="updating" class="loader">
      <div class="loading loading-lg"></div>
    </div>

    <template v-else>
      <div class="scroll-top" @click="scrollToTop">(^)</div>

      <div class="mb-2 container">
        <div class="input-group columns">
          <span class="input-group-addon col-sm-12">Search All By</span>
          <select id="category-filter" :class="[
      'form-select field-select  ',
      { 'is-error': hasSearchError },
    ]" v-model="searchOption">
            <option value>Pick a field</option>
            <option v-for="option in searchOptions" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
          <input class="form-input" type="text" id="search-for-something" placeholder="for..." v-model="sstring"
            @keydown.enter="search" />
          <button class="btn btn-primary input-group-btn" @click="search">
            Go
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  find,
  debounce,
  intersection,
  orderBy,
  sortBy,
  each,
  remove,
  includes
} from "lodash-es";
import { mapGetters } from "vuex";
import axios from "axios";
import Fuse from "fuse.js";
import Pagination from "../components/pagination.vue";
import utils from "../components/utils";
let fandomSearch;
let freeformSearch;
let relationshipSearch;
let optionalTagsSearch;
let charactersSearch;
let promptSearch;

// Remove english articles from fandom names
function removeArticlesCompare(o) {
  if (!o) {
    return;
  }
  const regex = /^(the\s|a\s|an\s)/i;
  if (!o.name) {
    return o;
  }
  return o.name.toLowerCase().replace(regex, "");
}

function normalizeStr(str) {
  if (!str || typeof str !== "string") {
    return;
  }
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

const searchOptions = [
  {
    name: "Character/Relationship",
    id: "individual"
  },
  {
    name: "Fandom",
    id: "fandom"
  },
  {
    name: "Freeform",
    id: "freeform"
  },
  {
    name: "Prompt",
    id: "prompt"
  },
  {
    name: "Username (Exact)",
    id: "user"
  }
];

export default {
  name: "everything",
  components: {
    Pagination
  },
  created() {
    this.load();
  },
  activated() {
    this.load();
  },
  destroyed() { },
  data() {
    return {
      pagination: {
        first: 0,
        last: 100,
        size: 100,
        total: 0
      },
      updating: true,
      fandom: "",
      user: "",
      prompts: [],
      filtered: [],
      showPrompt: [],
      sstring: "",
      view: "",
      limit: false,
      toggle: true,
      everythingFilter: "",
      everythingFiltered: [],
      hasSearchError: false,
      fandomFilter: undefined,
      freeformFilter: undefined,
      relationshipFilter: undefined,
      optionalTagFilter: undefined,
      characterFilter: undefined,
      promptFilter: undefined,
      searchOption: "",
      searchOptions,
      scrollIndex: 50,
      totalFound: 0
    };
  },
  computed: {
    ...mapGetters(["exchanges"]),
    filterCount() {
      let count = 0;

      if (this.fandomFilter && this.fandomFilter.length) {
        count++;
      }
      if (this.freeformFilter && this.freeformFilter.length) {
        count++;
      }
      if (this.relationshipFilter && this.relationshipFilter.length) {
        count++;
      }
      if (this.optionalTagFilter && this.optionalTagFilter.length) {
        count++;
      }
      if (this.characterFilter && this.characterFilter.length) {
        count++;
      }
      if (this.promptFilter && this.promptFilter.length) {
        count++;
      }
      return count;
    }
  },
  watch: {
    $route(to) {
      if (to.name == "everything") {
        this.$store.commit("setExchangeId", "");
        this.load();
      }
    },
    fandomFilter() {
      this.updateFilter();
    },
    characterFilter() {
      this.updateFilter();
    },
    freeformFilter() {
      this.updateFilter();
    },
    optionalTagFilter() {
      this.updateFilter();
    },
    relationshipFilter() {
      this.updateFilter();
    },
    promptFilter() {
      this.updateFilter();
    },
    limit() {
      this.load();
    }
  },
  methods: {
    hasEverythingBookmark: utils.hasEverythingBookmark,
    toggleEverythingBookmark: utils.toggleEverythingBookmark,
    removeEverythingBookmark: utils.removeEverythingBookmark,
    exchangeDate: utils.exchangeDate,
    async page(start) {
      this.pagination.last = start + this.pagination.size;
      this.pagination.first = start;
      this.load();
    },
    search() {
      if (!this.searchOption) {
        this.hasSearchError = true;
        return;
      }

      if (!this.sstring || !this.sstring.length) return;

      this.hasSearchError = false;
      if (this.searchOption == "user") {
        this.$router.push({
          path: `/everything/username/${encodeURIComponent(this.sstring)}`
        });
      } else {
        this.$router.push({
          path: `/everything/search/${this.searchOption}/${encodeURIComponent(this.sstring)}`
        });
      }
    },

    load() {
      this.updating = true;

      this.prompts = [];
      this.filtered = [];
      this.showPrompt = [];

      this.sstring = "";

      this.updating = false;
    },
    isExchangeOpen(ex) {
      if (this.exchanges) {
        var meta = find(this.exchanges, e => {
          return e.name == ex;
        });

        if (meta) {
          return meta.isOpen;
        }

        return false;
      }
    },
    togglePrompt(sha) {
      if (this.shouldShowPrompt(sha)) {
        this.showPrompt = remove(this.showPrompt, sha);
      } else {
        this.showPrompt.push(sha);
      }
    },
    shouldShowPrompt(sha) {
      return includes(this.showPrompt, sha);
    },
    setupFilters(result) {
      const fuseOptions = {
        shouldSort: true,
        threshold: 0,
        ignoreLocation: true,
        useExtendedSearch: true,
        getFn(obj, path) {
          //   // Use the default `get` function
          const value = Fuse.config.getFn(obj, path);
          //   // ... do something with `value`

          if (Array.isArray(value)) {
            return value.map(el => normalizeStr(el));
          }
          return normalizeStr(value);
        }
      };
      fandomSearch = new Fuse(result, {
        keys: ["fandoms", "fandom"],
        ...fuseOptions
      });
      relationshipSearch = new Fuse(result, {
        keys: ["relationships"],
        ...fuseOptions
      });
      freeformSearch = new Fuse(result, {
        keys: ["freeforms"],
        ...fuseOptions
      });

      charactersSearch = new Fuse(result, {
        keys: ["characters"],
        ...fuseOptions
      });

      optionalTagsSearch = new Fuse(result, {
        keys: ["optionalTags"],
        ...fuseOptions
      });

      promptSearch = new Fuse(result, {
        keys: ["prompt"],
        ...fuseOptions
      });
    },
    updateFilter: debounce(function () {
      this.updating = true;
      let arr = this.prompts;

      if (this.fandomFilter && this.fandomFilter.length) {
        const indices = fandomSearch.search(normalizeStr(this.fandomFilter));
        const res = [];
        each(indices, i => {
          res.push(this.prompts[i.refIndex]);
        });
        arr = intersection(arr, res);
      }

      if (this.relationshipFilter && this.relationshipFilter.length) {
        const indices = relationshipSearch.search(
          normalizeStr(this.relationshipFilter)
        );
        const res = [];
        each(indices, i => {
          res.push(this.prompts[i.refIndex]);
        });
        arr = intersection(arr, res);
      }
      if (this.characterFilter && this.characterFilter.length) {
        const indices = charactersSearch.search(
          normalizeStr(this.characterFilter)
        );
        const res = [];
        each(indices, i => {
          res.push(this.prompts[i.refIndex]);
        });
        arr = intersection(arr, res);
      }
      if (this.optionalTagFilter && this.optionalTagFilter.length) {
        const indices = optionalTagsSearch.search(
          normalizeStr(this.optionalTagFilter)
        );
        const res = [];
        each(indices, i => {
          res.push(this.prompts[i.refIndex]);
        });
        arr = intersection(arr, res);
      }
      if (this.freeformFilter && this.freeformFilter.length) {
        const indices = freeformSearch.search(
          normalizeStr(this.freeformFilter)
        );
        const res = [];
        each(indices, i => {
          res.push(this.prompts[i.refIndex]);
        });
        arr = intersection(arr, res);
      }
      if (this.promptFilter && this.promptFilter.length) {
        const indices = promptSearch.search(normalizeStr(this.promptFilter));
        const res = [];
        each(indices, i => {
          res.push(this.prompts[i.refIndex]);
        });
        arr = intersection(arr, res);
      }

      arr = orderBy(
        arr,
        [
          p =>
            this.exchangeDate(p.exchange, "due_date") ||
            this.exchangeDate(p.exchange, "timestamp"),
          p => this.exchangeDate(p.exchange, "timestamp"),
          "username"
        ],
        ["desc", "desc", "asc"]
      );

      this.totalFound = arr.length;

      this.filtered = arr;

      this.updating = false;
    }, 300),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss">
@import "../styles/app.scss";
@import "../styles/mobile.scss";
</style>


<style lang="scss" scoped>
@import "../styles/variables.scss";

.field-select {
  flex: 0 1 auto;
  width: 33%;
}

.prompt {
  margin: 0.8em 0;
  // border-bottom: 1px solid $outline-light;

  &:last-child {
    .break {
      display: none;
    }
  }
}

.bookmark,
.letter {
  height: 1.3em;
}

.user-data {
  font-size: larger;

  .letter {
    padding: 0;
    margin: 0;
    vertical-align: baseline;
  }

  .bookmark {
    position: relative;
    bottom: 4px;
    margin-right: 0.4em;
  }
}

.flex {
  margin-top: 0.4em;
  display: flex;
}

ul {
  li {
    margin: 0;
    padding: 4px 0;
    border-bottom: 1px solid $outline-light;

    &:last-child {
      border: 0;
    }

    &:first-child {
      padding-top: 0;
    }
  }
}

.requested-characters {
  // margin-top: 1em;
  margin-right: 1em;
  flex: 0 0 25%;
}

.toggle {
  width: 150px;
  height: 35px;
  display: block;
}

.break {
  width: 80%;
  margin: 0.8em auto;
}

@media screen and (max-width: 767px) {
  .flex {
    display: inherit;
  }

  .requested-characters {
    display: block;
    margin-bottom: 0.5em;
  }
}
</style>